import { createAsyncThunk } from '@reduxjs/toolkit';
import EventTypesService from '@/services/EventTypesService';

const handler = (name, asyncFunction) =>
  createAsyncThunk(`EventTypes/${name}`, async (arg) => {
    const data = await asyncFunction(arg);
    return data;
  });

export const getEventTypes = handler(
  'getEventTypes',
  EventTypesService.getEventTypes
);

export const getEventType = handler(
  'getEventType',
  EventTypesService.getEventType
);

export const deleteEventType = handler(
  'deleteEventType',
  EventTypesService.deleteEventType
);

export const deleteEventTypes = handler(
  'deleteEventTypes',
  EventTypesService.deleteEventTypes
);

export const createEventType = handler(
  'createEventType',
  EventTypesService.createEventType
);

export const updateEventType = handler('updateEventType', ({ id, data }) =>
  EventTypesService.updateEventType(id, data)
);
